var keyMirror = require('keymirror');

module.exports = keyMirror({
    TAB_SETTINGS_DATA: null,
    TAB_NAVIGATION_DATA: null,
    DELETE_NAVIGATION_DATA: null,
    UPDATE_NAVIGATION_DATA: null,
});